import { render, staticRenderFns } from "./UsualHeader.vue?vue&type=template&id=31a514bc&scoped=true&"
import script from "./UsualHeader.vue?vue&type=script&lang=js&"
export * from "./UsualHeader.vue?vue&type=script&lang=js&"
import style0 from "./UsualHeader.vue?vue&type=style&index=0&id=31a514bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a514bc",
  null
  
)

export default component.exports